<template>
  <answer
    @close="close"
    :mode="mode"
    @complete="complete"
    @submit="submit"
    v-show="step == 2"
    ref="answer"
  ></answer>
</template>
<script>
import Home from "./home";
import choose from "./choose";
import answer from "./answer";
import result from "./result";
import loginDialog from "../dialog/login/index";
import createAudio from "./audio";
export default {
  components: {
    Home,
    choose,
    answer,
    result,
  },
  data() {
    return {
      step: 2,
      remainTimes: 0,
      mode: "",
      audioSource: "",
      currectCommit: 0,
      play: false,
      unLogin: true,
    };
  },
  mounted() {
    this.startAnswer();
  },
  methods: {
    submit(showResult){
        localStorage.setItem('estee/showResult',showResult);
        this.$emit('submit',showResult)
    },
    audioPlay() {
      this.play = true;
      document.getElementById("myaudio").play();
    },
    playToggle() {
      if (this.play) {
        this.play = false;
        document.getElementById("myaudio").pause();
      } else {
        this.play = true;
        document.getElementById("myaudio").play();
      }
    },
    again() {
      this.step = 0;
      this.getRemainTimes();
      /* 重置答题部分前端数据 */
      this.$refs.answer.resetAnswer();
    },
    startAnswer() {
      this.choose();
    },
    close() {
      this.$emit("close");
    },
    choose() {
      this.$axios.post("/esteelauder/topic", {}).then((res) => {
        if (res.code == 400) {
        //   loginDialog({
        //     callback: () => {
        //       this.choose();
        //     },
        //   });
        } else if (res.code == 200) {
          var questions = [];
          res.data.forEach((item, index) => {
            var arr = [];
            var ind = 0;
            var map = ["A.", "B.", "C.", "D."];
            var optionsList = [];
            var specialArr =
              []; /* 目前只针对文案为以上都不是的选项，放到最后一位 */

            item.optionsList.forEach((child, index) => {
              if (child.optionsContent != "以上都不是") {
                optionsList.push({ ...child, error: false, correct: false });
              } else {
                specialArr.push({
                  option:map[3],
                  label: child.optionsContent,
                  id: child.id,
                  error: false,
                  correct: false,
                  parentId: item.topicRecordId,
                  active: false,
                });
              }
            });
            var len = optionsList.length;
            // while(ind < len){
            //     var ran = Math.floor((Math.random()*(optionsList.length*100)/100));
            //     var child = optionsList[ind];
            //     arr.push({
            //         label:map[ind]+child.optionsContent,
            //         id:child.id,
            //         error:false,
            //         correct:false,
            //         parentId:item.topicRecordId,
            //         active:false
            //     });
            //     optionsList.splice(ind,1);
            //     ind++;
            // }
            optionsList.forEach((child, ind) => {
              arr.push({
                option:map[ind],
                label:child.optionsContent,
                id: child.id,
                error: false,
                correct: false,
                parentId: item.topicRecordId,
                active: false,
              });
            });
            questions.push({
              title: item.topicTitle,
              topicRecordId: item.topicRecordId,
              result: arr,
            });
          });
          this.step = 2;
          this.$refs.answer.setQuestions(questions);
        } else {
          this.$dialog.alert({
            message: res.message,
          });
        }
      });
    },
    complete({ currectCommit, topicRecordId }) {
      if (currectCommit == -1) {
        /* 说明没有次数想访问结果页 */
        this.step = 2;
        // this.$refs.result.getRemainTimes();
        // this.$refs.result.toprank();
        // this.$refs.result.myOwnInfo(true);
        return;
      }
      this.currectCommit = currectCommit;
      this.step = 3;
      this.$refs.result.getRemainTimes();
      this.$refs.result.myOwnInfo(false, topicRecordId);
    },
  },
};
</script>
<style lang='less' scoped="true">
.bgm {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 30px;
  z-index: 2;
}
.rotate {
  animation: rotate linear 2s infinite;
}
@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
#myaudio {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  display: none;
}
</style>